import { render, staticRenderFns } from "./MbEricksonHeader.vue?vue&type=template&id=d1777034&"
import script from "./MbEricksonHeader.vue?vue&type=script&lang=js&"
export * from "./MbEricksonHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports